import api from "./api";

// Enum TipoChavePix — espelha C# (ordem importa).
export const TIPO_CHAVE_PIX = {
  CPF: 0,
  CNPJ: 1,
  Email: 2,
  Telefone: 3,
  Aleatoria: 4,
};

export const TIPO_CHAVE_PIX_LABEL = {
  0: "CPF",
  1: "CNPJ",
  2: "E-mail",
  3: "Telefone",
  4: "Aleatória",
};

export async function getMe() {
  const { data } = await api.get("/Profile/me");
  return data;
}

export async function updateMe(payload) {
  const { data } = await api.put("/Profile/me", payload);
  return data;
}

// Upload/remove da logo do guia (white-label). Ambos devolvem o ProfileDto
// atualizado — o caller deve propagar via AuthContext.refreshProfile()
// pra que a sidebar reflita imediatamente.
export async function uploadLogo(file) {
  const formData = new FormData();
  formData.append("file", file);
  const { data } = await api.post("/Profile/me/logo", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}

export async function deleteLogo() {
  const { data } = await api.delete("/Profile/me/logo");
  return data;
}
